import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Layout from './components/Layout';
import Home from './pages/Home';
import Dashboard from './pages/Dashboard';
import ProspectsList from './pages/ProspectsList';
import ProspectDetail from './pages/ProspectDetail';
import ProspectQuestionnaire from './pages/ProspectQuestionnaire';
import Login from './pages/Login';
import Register from './pages/Register';
import MyApplication from './pages/MyApplication';
import ProfessorPathway from './pages/ProfessorPathway';
import ProgramsManagement from './pages/ProgramsManagement';
import PartnersManagement from './pages/PartnersManagement';
import ScholarshipsManagement from './pages/ScholarshipsManagement';
import ProfessorsManagement from './pages/ProfessorsManagement';
import UsersManagement from './pages/UsersManagement';
import InfoSessionsManagement from './pages/InfoSessionsManagementPage';
import Analytics from './pages/Analytics';
import PartnerDiscount from './pages/PartnerDiscount';
import PartnerDiscountsManagement from './pages/PartnerDiscountsManagement';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import EnrollmentRefundPolicy from './pages/EnrollmentRefundPolicy';
import LeadThanks from './pages/LeadThanks';
import AdvisorInbox from './pages/AdvisorInbox';
import ProfileSettings from './pages/ProfileSettings';
import ProgramPortalPage from './pages/ProgramPortalPage';
import TestimonialSubmit from './pages/TestimonialSubmit';
import TestimonialsManagement from './pages/TestimonialsManagement';
import PrivateRoute from './components/PrivateRoute';
import AnalyticsTracker from './components/AnalyticsTracker';
import ImpersonationBanner from './components/ImpersonationBanner';

function App() {
  return (
    <AuthProvider>
      <Router>
        <AnalyticsTracker />
        <ImpersonationBanner />
        <div className="min-h-screen bg-gray-50">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/enrollment-refund-policy" element={<EnrollmentRefundPolicy />} />
            <Route path="/lead-thanks" element={<LeadThanks />} />
            <Route path="/testimonial/submit" element={<TestimonialSubmit />} />
            <Route path="/partner/:slug" element={<PartnerDiscount />} />
            
            {/* User Self-Service Routes */}
            <Route path="/student-pathway" element={
              <PrivateRoute>
                <MyApplication />
              </PrivateRoute>
            } />
            <Route path="/student-pathway/program-portal" element={
              <PrivateRoute>
                <ProgramPortalPage />
              </PrivateRoute>
            } />
            {/* Legacy alias route for backward compatibility */}
            <Route path="/my-application" element={<Navigate to="/student-pathway" replace />} />
            <Route path="/professor-pathway" element={
              <PrivateRoute>
                <ProfessorPathway />
              </PrivateRoute>
            } />
            
            
            {/* Admin Routes */}
            <Route path="/admin/dashboard" element={
              <PrivateRoute adminOnly={true}>
                <Layout>
                  <Dashboard />
                </Layout>
              </PrivateRoute>
            } />
            <Route path="/admin/profile" element={
              <PrivateRoute adminOnly={true}>
                <Layout>
                  <ProfileSettings />
                </Layout>
              </PrivateRoute>
            } />
            <Route path="/admin/prospects/:id/questionnaire" element={
              <PrivateRoute adminOnly={true}>
                <Layout>
                  <ProspectQuestionnaire />
                </Layout>
              </PrivateRoute>
            } />
            <Route path="/admin/prospects" element={
              <PrivateRoute adminOnly={true}>
                <Layout>
                  <ProspectsList />
                </Layout>
              </PrivateRoute>
            } />
            <Route path="/admin/prospects/:id" element={
              <PrivateRoute adminOnly={true}>
                <Layout>
                  <ProspectDetail />
                </Layout>
              </PrivateRoute>
            } />
            <Route path="/admin/programs" element={
              <PrivateRoute adminOnly={true}>
                <Layout>
                  <ProgramsManagement />
                </Layout>
              </PrivateRoute>
            } />
            <Route path="/admin/testimonials" element={
              <PrivateRoute adminOnly={true}>
                <Layout>
                  <TestimonialsManagement />
                </Layout>
              </PrivateRoute>
            } />
            <Route path="/admin/partners" element={
              <PrivateRoute adminOnly={true}>
                <Layout>
                  <PartnersManagement />
                </Layout>
              </PrivateRoute>
            } />
            <Route path="/admin/scholarships" element={
              <PrivateRoute adminOnly={true}>
                <Layout>
                  <ScholarshipsManagement />
                </Layout>
              </PrivateRoute>
            } />
            <Route path="/admin/scholarships-management" element={
              <PrivateRoute adminOnly={true}>
                <Layout>
                  <ScholarshipsManagement />
                </Layout>
              </PrivateRoute>
            } />
            <Route path="/admin/professors" element={
              <PrivateRoute adminOnly={true}>
                <Layout>
                  <ProfessorsManagement />
                </Layout>
              </PrivateRoute>
            } />
            <Route path="/admin/users" element={
              <PrivateRoute adminOnly={true}>
                <Layout>
                  <UsersManagement />
                </Layout>
              </PrivateRoute>
            } />
            <Route path="/admin/info-sessions" element={
              <PrivateRoute adminOnly={true}>
                <Layout>
                  <InfoSessionsManagement />
                </Layout>
              </PrivateRoute>
            } />
            <Route path="/admin/analytics" element={
              <PrivateRoute adminOnly={true}>
                <Layout>
                  <Analytics />
                </Layout>
              </PrivateRoute>
            } />
            <Route path="/admin/advisor-inbox" element={
              <PrivateRoute adminOnly={true}>
                <Layout>
                  <AdvisorInbox />
                </Layout>
              </PrivateRoute>
            } />
            <Route path="/admin/partner-discounts" element={
              <PrivateRoute adminOnly={true}>
                <Layout>
                  <PartnerDiscountsManagement />
                </Layout>
              </PrivateRoute>
            } />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
